import styled from 'styled-components';

export const StyledMenuSection = styled('div')<{ canOverflow: boolean }>`
  display: flex;
  flex-flow: nowrap column;
  overflow-y: ${(p) => (p.canOverflow ? 'auto' : 'visible')};
  overflow-x: ${(p) => (p.canOverflow ? 'hidden' : 'visible')};
`;
